import { render, staticRenderFns } from "./bpb-questionnaire-question.vue?vue&type=template&id=a6f4cb52&"
import script from "./bpb-questionnaire-question.vue?vue&type=script&lang=js&"
export * from "./bpb-questionnaire-question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports